// extracted by mini-css-extract-plugin
export default {"showInlineImages":"fTBTR3qz0M","emailDate":"Z5GCWb6pY5"};